import firebase from "firebase/app";
import { giftCardCollection } from "@/firebase";
//import { storage } from "@/firebase";

const state = {
  giftCard: [],
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  checkGiftCardIfExists({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCardCollection
        .where("client", "==", payload.client)
        .where("code", "==", payload.code)
        .limit(1)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            resolve(false);
          } else resolve(true);
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  getGiftCard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCardCollection
        .where("client", "==", payload.client)
        .where("closed", "==", payload.closed)
        .orderBy("validTo", "asc")
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          querySnapshot.forEach((doc) => {
            tempData.push(Object.assign(doc.data(), { id: doc.id }));
          });
          resolve(commit("getGiftCard", tempData));
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  addGiftCard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // če vnesemo zapis ročno preko predloge, moramo prej pretvoriti datum v pravo obliko
      if (!payload.automaticInsert) {
        payload.timestamp = firebase.firestore.Timestamp.fromDate(
          new Date(payload.timestamp)
        );
        payload.validTo = firebase.firestore.Timestamp.fromDate(
          new Date(payload.validTo)
        );
      }
      payload.value = Number(payload.value);

      giftCardCollection
        .add(payload)
        .then((docRef) => {
          //console.log("Added record.");
          commit(
            "addGiftCard",
            Object.assign(payload, { id: docRef.id })
          );
          resolve(true);
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  removeGiftCard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCardCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeGiftCard", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  editGiftCard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.timestamp = firebase.firestore.Timestamp.fromDate(
        new Date(payload.timestamp)
      );
      payload.validTo = firebase.firestore.Timestamp.fromDate(
        new Date(payload.validTo)
      );
      payload.value = Number(payload.value);

      giftCardCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftCard", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftCardBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.closed = !payload.closed;
      giftCardCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftCard", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getGiftCard(state, payload) {
    state.giftCard = payload;
    //console.log(state.giftCard);
  },
  addGiftCard(state, payload) {
    state.giftCard.push(payload);
    //console.log(state.giftCard);
  },
  removeGiftCard(state, payload) {
    const index = state.giftCard.findIndex((item) => item.id == payload);
    state.giftCard.splice(index, 1);
  },
  editGiftCard(state, payload) {
    const index = state.giftCard.findIndex((item) => item.id == payload.id);
    // če smo spremenili closed v true, potem izločimo zapis iz state-a
    if (payload.closed) {
      state.giftCard.splice(index, 1);
    } else
      state.giftCard.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};